import sendRequest from '@/api/sendRequest'
import { usePopupAlerts } from '@/v1/hooks'
import { UploadedFileType } from '@/types/global'

export function useDownloadAsset() {
  const { sendNotification } = usePopupAlerts()

  const downloadAsset = (file: UploadedFileType) => {
    const assetUrl = file?.download_link

    sendRequest({
      url: assetUrl,
      responseBlob: true
    })
      .then(res => {
        if (res.statusCode === 200) {
          const blob = res.data

          const url = window.URL.createObjectURL(new Blob([blob]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', file?.show_file_name || file?.file_name)
          document.body.appendChild(link)
          link.click()
          link.remove()
        } else {
          sendNotification('error', 'Download failed. Apologies for the inconvenience.')
        }
      })
      .catch(error => console.error('Error downloading asset:', error))
  }

  return {
    downloadAsset
  }
}
